import { registerPlugin } from '@capacitor/core';

export interface StashtPreferencesPlugin {
  saveTokens(options: { accessToken: string; refreshToken?: string }): Promise<void>;
  getTokens(): Promise<{ accessToken: string | null; refreshToken: string | null }>;
  clearTokens(): Promise<void>;
}

const StashtPreferences = registerPlugin<StashtPreferencesPlugin>('StashtPreferences', {
  web: () => {
    // Web implementation (no-op for web platform)
    return {
      async saveTokens() {
        console.log('[StashtPreferences] Web platform - tokens not saved');
      },
      async getTokens() {
        return { accessToken: null, refreshToken: null };
      },
      async clearTokens() {
        console.log('[StashtPreferences] Web platform - tokens not cleared');
      },
    };
  },
});

export default StashtPreferences;

